//controller deals with landing page for playlist viewing
module.exports = ['$scope', '$rootScope', 'playlist', 'PlaylistItemsLoader', function PlaylistLandingCtrl($scope, $rootScope, playlist, PlaylistItemsLoader) {
    $scope.playlist = playlist;

    $scope.playlistItemsLoader = PlaylistItemsLoader({
        playlistId: playlist.id
    }).getAll();

    $scope.downloadPlaylist = function(playlist) {
        $rootScope.$emit(
            'MEDIA_DOWNLOAD',
            $scope.playlistItemsLoader.data,
            { filename: playlist.name },
            { name: 'playlist' }
        );
    };
}];


// WEBPACK FOOTER //
// ./vendor/sonyatv/playlistclientbundle/Resources/js/angular/controllers/PlaylistLandingCtrl.js